import { withKey, API_BASE } from '../services/utils';

// Fetch lead by id
export const fetchLeadById = async (leadId) => {
  if (!leadId) return null;
  try {
    const response = await fetch(await withKey(`${API_BASE}/api/zoho/leads/${encodeURIComponent(leadId)}`));
    const data = await response.json();
    if (data && data.id) {
      return {
        id: data.id,
        name: data.name || '',
        email: data.email || ''
      };
    }
  } catch (error) {
    console.error('Error fetching lead by id:', error);
  }
  return null;
};

// Fetch deal by id
export const fetchDealById = async (dealId) => {
  if (!dealId) return null;
  try {
    const response = await fetch(await withKey(`${API_BASE}/api/zoho/deals/${encodeURIComponent(dealId)}`));
    const data = await response.json();
    if (data && data.id) {
      return {
        id: data.id,
        name: data.name || ''
      };
    }
  } catch (error) {
    console.error('Error fetching deal by id:', error);
  }
  return null;
};

export const fetchOffersList = async (search = '') => {
  try {
    const response = await fetch(
      await withKey(`${API_BASE}/api/zoho/offers/list?search=${encodeURIComponent(search)}`)
    );
    const data = await response.json();
    return data?.offers || [];
  } catch (error) {
    console.error('Error fetching offers list:', error);
    return [];
  }
};

export const fetchOfferItemsById = async (offerId) => {
  if (!offerId) return { items: [] };
  try {
    const response = await fetch(
      await withKey(`${API_BASE}/api/zoho/offers/${encodeURIComponent(offerId)}/offered_items`)
    );
    const data = await response.json();
    if (data?.error) {
      throw new Error(data.error);
    }
    return {
      offer_name: data?.offer_name || '',
      items: data?.items || [],
    };
  } catch (error) {
    console.error('Error fetching offer items by id:', error);
    throw error;
  }
};
